import { render, staticRenderFns } from "./FinanceAccount.vue?vue&type=template&id=64708371&scoped=true"
import script from "./FinanceAccount.vue?vue&type=script&lang=js"
export * from "./FinanceAccount.vue?vue&type=script&lang=js"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&id=64708371&prod&scoped=true&lang=css&external"
import style1 from "bootstrap-vue/dist/bootstrap-vue.css?vue&type=style&index=1&id=64708371&prod&scoped=true&lang=css&external"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=64708371&prod&scoped=true&lang=css&external"
import style3 from "./FinanceAccount.vue?vue&type=style&index=3&id=64708371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64708371",
  null
  
)

export default component.exports